"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Auth from "../util/auth";
import { ErrorWithResponse } from "../util/fetch";
import "../api/account";
import DisablingButton from "./disabling_button";
import { Flash } from "../components/flash";
import FormInput from "../util/form_input";
import presenceService from "./presence_service_next_gen";
import "../util/feature_flags";
import WaitingSpinner from "../components/waiting_spinner";
import Reskin from "../helpers/reskin";
import { replace } from "./app_history";
function loginEmailLabel(state) {
  if (state.oktaEnabled == null) {
    return;
  }
  return /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx("label", { className: "mb-2", children: state.email }) });
}
function loginError(state) {
  const error = state.loginError;
  if (error) {
    return /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx("div", { className: "alert-box alert radius", children: error }) });
  }
}
function loginComplete(props, user) {
  presenceService.startForUser(user);
  const location = props.location;
  if (location.state && location.state.nextPathname) {
    replace(location.state.nextPathname);
  } else {
    replace("/");
  }
}
class LoginForm extends React.Component {
  constructor() {
    super(...arguments);
    // LIFECYCLE
    __publicField(this, "state", {
      loading: true,
      loginError: null,
      sending: false,
      fetchingOktaStatus: false,
      oktaEnabled: null,
      email: "",
      password: "",
      showPasswordReset: false,
      sendingEmail: false,
      passwordResetOrigin: document.referrer.includes("/password/edit")
    });
    __publicField(this, "authenticate", (e) => {
      e.preventDefault();
      if (this.state.password === "") {
        return;
      }
      this.setState({ sending: true, loginError: null });
      Auth.login({
        email: this.state.email,
        password: this.state.password
      }).then((user) => {
        Flash.success("Logged in as " + user.display_name);
        loginComplete(this.props, user);
      }).catch((error) => {
        if (!(error instanceof ErrorWithResponse)) return;
        const response = error.response;
        if (response.status === 401 || response.status === 403) {
          void response.json().then((json) => {
            this.setState({
              loginError: json.error,
              sending: false,
              password: ""
            });
          });
        }
      });
    });
    __publicField(this, "resetPassword", (e) => {
      e.preventDefault();
      var emailMessage = "We\u2019ve sent an email to this account, if it exists. If you do not receive one, please confirm with your account administrator that you have access";
      this.setState({ sendingEmail: true });
      Auth.requestPasswordReset({
        email: this.state.email
      }).finally(() => {
        Flash.success(emailMessage);
        this.setState({
          sendingEmail: false,
          loginError: null
        });
        this.toggleResetPasswordForm();
      });
    });
    __publicField(this, "emailChanged", (e) => {
      this.setState({ email: e.target.value });
    });
    __publicField(this, "passwordChanged", (e) => {
      this.setState({ password: e.target.value });
    });
    __publicField(this, "getOktaStatus", (e) => {
      const emailAddress = this.state.email;
      this.setState({ fetchingOktaStatus: true, loginError: null }, () => {
        Auth.getOktaStatus(emailAddress).then((response) => {
          const oktaEnabled = response.oktaEnabled;
          this.setState(
            { fetchingOktaStatus: false, oktaEnabled },
            () => {
              if (oktaEnabled) {
                replace("/okta_login", {
                  e: emailAddress
                });
              } else {
                this.setState({ password: "" });
              }
            }
          );
        }).catch((_error) => {
          this.setState({
            fetchingOktaStatus: false,
            loginError: "An error occurred."
          });
        });
      });
    });
    __publicField(this, "handleEmailKeyDown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        if (this.state.email > "") {
          this.getOktaStatus();
        }
      }
    });
    __publicField(this, "toggleResetPasswordForm", () => {
      this.setState((prevState) => ({
        showPasswordReset: !prevState.showPasswordReset,
        password: "",
        loginError: null
      }));
    });
    __publicField(this, "resetLoginForm", () => {
      this.setState({
        email: "",
        oktaEnabled: null,
        password: "",
        loginError: null
      });
    });
    __publicField(this, "successfulPasswordReset", () => {
      if (this.state.passwordResetOrigin) {
        Flash.success("Password successfully reset.");
        this.setState({ passwordResetOrigin: false });
      }
    });
    __publicField(this, "loginEmailInput", () => {
      if (this.state.oktaEnabled != null) {
        return;
      }
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          FormInput,
          {
            placeholder: "Email",
            onChange: this.emailChanged,
            value: this.state.email,
            id: "username_field",
            divClasses: "small-12 column",
            label: "Email",
            onKeyDown: this.handleEmailKeyDown,
            type: "email"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
          DisablingButton,
          {
            type: "button",
            onClick: this.getOktaStatus,
            disabledText: "\u2026",
            disabled: this.state.fetchingOktaStatus,
            className: "button--confirmation",
            children: "Continue"
          }
        ) })
      ] });
    });
    __publicField(this, "loginPasswordInput", () => {
      if (this.state.oktaEnabled == null) {
        return;
      }
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          FormInput,
          {
            placeholder: "Password",
            onChange: this.passwordChanged,
            value: this.state.password,
            id: "password_field",
            divClasses: "small-12 column",
            label: "Password",
            type: "password"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabledText: "Signing in\u2026",
            disabled: this.state.sending,
            className: "button--confirmation",
            children: "Sign In"
          }
        ) })
      ] });
    });
    __publicField(this, "loginForm", () => {
      if (!this.state.loading && !this.state.showPasswordReset) {
        return /* @__PURE__ */ jsxs("div", { className: "small-6 small-centered column general-container-style", children: [
          /* @__PURE__ */ jsx("h3", { children: "Sign in to Triumph Audit" }),
          /* @__PURE__ */ jsx("form", { onSubmit: this.authenticate, name: "loginForm", children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
            loginError(this.state),
            this.loginEmailInput(),
            loginEmailLabel(this.state),
            this.loginPasswordInput(),
            this.showPasswordResetLink(),
            this.showBackToSignInLink()
          ] }) })
        ] });
      }
    });
    __publicField(this, "showPasswordResetLink", () => {
      if (this.state.email && this.state.oktaEnabled != null) {
        return /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: this.toggleResetPasswordForm,
            className: "button--link-v2",
            children: "Reset password?"
          }
        ) });
      }
    });
    __publicField(this, "showBackToSignInLink", () => {
      if (this.state.email && this.state.oktaEnabled != null) {
        return /* @__PURE__ */ jsx("div", { className: "small-12 column my-2", children: /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: this.resetLoginForm,
            className: "button--link-v2",
            children: "Back to sign in"
          }
        ) });
      }
    });
    __publicField(this, "passwordResetForm", () => {
      if (this.state.showPasswordReset) {
        return /* @__PURE__ */ jsxs("div", { className: "small-6 small-centered column general-container-style", children: [
          /* @__PURE__ */ jsx("h3", { children: "Reset Password" }),
          /* @__PURE__ */ jsx("form", { onSubmit: this.resetPassword, name: "passwordResetForm", children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
            /* @__PURE__ */ jsx(
              FormInput,
              {
                placeholder: "Email",
                onChange: this.emailChanged,
                value: this.state.email,
                id: "username_field",
                divClasses: "small-12 column",
                label: "Email",
                type: "email"
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
              DisablingButton,
              {
                disabledText: "Sending Email...",
                disabled: this.state.sendingEmail,
                className: "button--confirmation",
                children: "Send Reset Email"
              }
            ) }),
            /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: this.toggleResetPasswordForm,
                className: "button--link-v2",
                children: "Cancel"
              }
            ) })
          ] }) })
        ] });
      }
    });
  }
  componentDidMount() {
    Auth.currentUser().then((user) => {
      loginComplete(this.props, user);
    }).catch((error) => {
      Reskin.clearToggleUser();
      if (error instanceof ErrorWithResponse && (error.response.status === 401 || error.response.status == 403)) {
        this.setState({ loading: false });
        this.successfulPasswordReset();
      } else {
        throw error;
      }
    });
  }
  render() {
    return /* @__PURE__ */ jsx(WaitingSpinner, { "data-component": "LoginForm", when: this.state.loading, children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
      this.loginForm(),
      this.passwordResetForm()
    ] }) });
  }
}
export default LoginForm;
